import React from 'react';
import { Helmet } from 'react-helmet';
const CleaningTasks = ({ tasks }) => {
  return (
    <>
    <Helmet>
      <title>I'm Your Huckleberry | Services</title>
    </Helmet>
    <div className="container py-4">
      <h2 className="mb-3">Services Include:</h2>
      <ul className="list-unstyled ps-3">
        {tasks.map((task, index) => (
          <li key={index} className="mb-2">
            ● {task}
          </li>
        ))}
      </ul>
    </div>
    </>
  );
};

export default CleaningTasks;
